import {FC} from "react"
import Image from "next/image"

import {ModalLayout} from "components/modal/base"
import {Button} from "components/button"
import {ModalProps} from "lib/hooks/useModal"
import whereMyCodeImg from "public/images/where-my-code.png"

const WhereIsMyCodeModal: FC<ModalProps> = ({isOpened, close}) => (
  <ModalLayout isOpened={isOpened} close={close}>
    <div className="h-full flex flex-col items-stretch px-5 tablet:px-32 tablet:pt-16 tablet:pb-12">
      <div className="my-8 tablet:mt-2 tablet:mx-16">
        <Image src={whereMyCodeImg} layout="responsive" alt="" />
      </div>
      <h1>Can’t find your code?</h1>
      <p className="text-body-4 mt-8">
        Check with your HR to confirm they sent it to the correct email.
        Also, check your spam folder to make sure it didn’t get caught up in there.
      </p>
      <div className="grow" />
      <Button onClick={close} className="mt-12 mb-5 self-center">
        Got it
      </Button>
    </div>
  </ModalLayout>
)

export default WhereIsMyCodeModal
